export default __webpack_public_path__ + "static/media/3.a6e05708.png";